// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ChromeFilledSvg from "@ant-design/icons-svg/es/asn/ChromeFilled";
import AntdIcon from '../components/AntdIcon';

var ChromeFilled = function ChromeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ChromeFilledSvg
  }));
};

ChromeFilled.displayName = 'ChromeFilled';
export default React.forwardRef(ChromeFilled);